module.exports = __webpack_public_path__ + "static/media/guiaDeEstudioTercerQuiz.bda2ffba.pdf";